export const countUnicodeCharacters = (value?: string) => {
  return Array.from(value ?? '').length
}
